import React, { Dispatch } from 'react';
import * as L from 'leaflet';
import {
  FilterData,
  GlobalDateFilter,
  DashboardLayerConfig,
} from 'types/types';
import { AnyAction } from '@reduxjs/toolkit';
import { updateLayerByLayerId } from 'features/advancedMapState';

export interface NiLayerOptions extends L.LayerOptions {
  layerDefinition: DashboardLayerConfig;
  minZoom?: number;
  maxZoom?: number;
  reduxDispatchCallback: Dispatch<AnyAction>;
  selectedLayersLoading: React.MutableRefObject<any[]>;
  initialFiltersState: FilterData[];
  initialGlobalDateFilter: GlobalDateFilter;
  initialBaseMarkers: any[];
  layersLoadedFromCache?: any;
  cachedData: any;
  opacity?: number;
}

export class LeafletExtensionNIBaseLayer extends L.FeatureGroup {
  protected internalLoadingFlag: boolean;
  public readonly niLayerOptions: NiLayerOptions;
  protected currentFiltersState: FilterData[];
  protected currentGlobalDateFilter: GlobalDateFilter;
  protected currentBaseMarkers: any[];

  constructor(options: NiLayerOptions) {
    super(undefined, options);
    this.currentFiltersState = options.initialFiltersState;
    this.currentGlobalDateFilter = options.initialGlobalDateFilter;
    this.currentBaseMarkers = options.initialBaseMarkers;

    this.niLayerOptions = options;

    this.internalLoadingFlag = false;
  }

  /**
   * This method is called by the advanced map, when the base layers
   * is updated
   */
  public baseMarkersLoadedOrRefreshed(newBaseMarkers: any[]): void {
    this.currentBaseMarkers = newBaseMarkers;
  }

  /**
   * This method is called by the advanced map, when:
   * 1-region filter changed (will be withing the newFiltersState)
   * 2-Global DAte Filter Changes
   * 3-Any Selected KPI or Neighbour KPI changes (will be withing the newFiltersState)
   */
  public async filtersChanged(
    newFiltersState: FilterData[],
    newGlobalDateFilter: GlobalDateFilter
  ): Promise<void> {
    this.currentFiltersState = newFiltersState;
    this.currentGlobalDateFilter = newGlobalDateFilter;
  }

  public setNewLoadingState(value: boolean): void {
    if (this.internalLoadingFlag !== value) {
      this.internalLoadingFlag = value;
      this.niLayerOptions.reduxDispatchCallback(
        updateLayerByLayerId({
          LayerId: this.niLayerOptions.layerDefinition.LayerId,
          diff: {
            isLoading: this.internalLoadingFlag
          }
        })
      );
    }
  }

  onAdd(map: L.Map): this {
    map.on('zoomend', this._internalOnZoomEnd, this);
    super.onAdd(map);

    // call the method to verify if we need to handle the layer
    // based on this initial zoom level
    this._internalOnZoomEnd();

    return this;
  }

  onRemove(map: L.Map): this {
    map.off('zoomend', this._internalOnZoomEnd, this);
    return super.onRemove(map);
  }

  private _internalOnZoomEnd(): void {
    const currentZoom = this._map?.getZoom();
    const { minZoom = 0, maxZoom = 18 } = this.niLayerOptions;

    if (
      currentZoom !== undefined &&
      (currentZoom < minZoom || currentZoom > maxZoom)
    ) {
      this._handleLayerOutOfZoom();
    } else {
      this._handleLayerWithinZoomBoundaries();
    }
  }

  protected _handleLayerOutOfZoom(): void {
    /*if (this._map && this._map.hasLayer(this._internalGeoJsonLayer)) {
      this._map.removeLayer(this._internalGeoJsonLayer);
    }*/
  }

  protected _handleLayerWithinZoomBoundaries(): void {
    /*if (this._map && !this._map.hasLayer(this._internalGeoJsonLayer)) {
      this._internalGeoJsonLayer.addTo(this._map);
    }*/
  }

}
